import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {IProveedor} from '../modelos/IProveedor';

@Injectable({
  providedIn: 'root'
})
export class ProveedorService {

  private diccionarioModulo: any;
  private url: string;
  private urlMaestros: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
    this.urlMaestros = this._util.getDatosMaestros();
  }

  obtenerPorId(id: string): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioModulo.url.proveedor.obtenerPorId + id
    );
  }

  obtenerPorRuc(ruc: string): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioModulo.url.proveedor.obtenerPorRuc + ruc
    );
  }
}
